export default "__VITE_ASSET__Bji04jvw__"